import './util/bootstrap';
import Router from './util/router';
import common from './routes/common';
import home from './routes/home';
import page from './routes/page';
import pageTemplateMembership from './routes/pageTemplateMembership';
import taxEventType from './routes/taxEventType';
import pageId288 from './routes/pageId288';
import cssVars from 'css-vars-ponyfill';

const routes = new Router({
  common,
  home,
  page,
  pageTemplateMembership,
  taxEventType,
  pageId288
});

$(document).ready(() => routes.loadEvents());

cssVars({
  include: 'link[rel=stylesheet],style',
  onError: function(message, elm, xhr, url) {
    console.log(message); // 1
    console.log(elm); // 2
    console.log(xhr.status); // 3
    console.log(xhr.statusText); // 4
    console.log(url); // 5
  }
});
